/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type InvoiceExtraType =
  (typeof InvoiceExtraType)[keyof typeof InvoiceExtraType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceExtraType = {
  Utdragen: 0,
  VstBesok: 1,
  HamtDack: 2,
  FelAdress: 3,
  FelAnlagg: 4,
  Vant: 5,
  Elbil: 6,
  Hotell: 8,
  Tvatt: 9,
  Dackskifte: 10,
  EjBokatInbyte: 11,
  Direktbok: 12,
  SuperObd: 13,
  Spolarvatska: 14,
  Adblue: 15,
  HamtKontor: 16,
  Motorolja: 17,
  Glykol: 18,
  Taxi: 19,
  Fulltank: 20,
} as const;
